import { DataProvider } from "react-admin";
import { apiUrl, httpClient } from "../httpClient";
import type { RequestOptions } from "../types/api";
import { ADMIN_BASE } from "../config";

export abstract class BaseDataProvider implements Partial<DataProvider> {
  resource: string;

  constructor(resource: string) {
    this.resource = resource;
  }

  protected async makeRequest(
    endpoint: string,
    options: RequestOptions = {},
  ): Promise<unknown> {
    try {
      const url = apiUrl(`${ADMIN_BASE}/${endpoint}`);
      const { json } = await httpClient(url, options);
      return json;
    } catch (error) {
      console.error(`API request failed for ${endpoint}:`, error);
      throw error;
    }
  }

  protected buildQueryParams(params: {
    pagination?: { page: number; perPage: number };
    sort?: { field: string; order: "ASC" | "DESC" };
    filter?: Record<string, unknown>;
  }): URLSearchParams {
    const { page, perPage } = params.pagination || { page: 1, perPage: 20 };
    const { field, order } = params.sort || {
      field: "createdAt",
      order: "DESC",
    };

    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: perPage.toString(),
    });

    if (field && order) {
      queryParams.append("sortBy", field);
      queryParams.append("sortOrder", order);
    }

    if (params.filter) {
      Object.entries(params.filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, String(value));
        }
      });
    }

    return queryParams;
  }

  protected transformListResponse(response: unknown): {
    data: unknown[];
    total: number;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } {
    const apiResponse = response as {
      data: unknown[];
      total: number;
      pageInfo?: {
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      };
    };

    return {
      data: apiResponse.data || [],
      total: apiResponse.total || 0,
      pageInfo: {
        hasNextPage: apiResponse.pageInfo?.hasNextPage || false,
        hasPreviousPage: apiResponse.pageInfo?.hasPreviousPage || false,
      },
    };
  }
}
